// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_ilC","cls2":"ResearchExamples-cls2_Y05 ResearchExamples-cls1_ilC"};